import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../new_template_common/breadcrumb/BreadCrumb";
import ProductImageSlider from "./ProductImageSlider";
import "../css/product-details.css";
import PriceBreakUp from "./price-breakup";
import ProductDescription from "./productDescription";
import QuantityCounter from "./QuantityCounter";
import ProductActions from "./ProductActions";

import classes from "./productDetail.module.scss";
import ProductImageGrid from "./ProductImageGrid";
import ButtonSpinner from "../../common/ButtonSpinner";

const ProductDetails = (props) => {
  const [qty, setQty] = useState(1);
  const [copyText, setCopyText] = useState();
  const [Data, setData] = useState({
    inStock: "",
    images: [],
    variants: [],
  });
  const [isActive, setIsActive] = useState(false);
  const [isCompareActive, setIsCompareActive] = useState(false);
  const [addingToCart, setAddingToCart] = useState(false);

  const {
    item,
    BuynowClicked,
    symbol,
    onRemoveFromWishlistClicked,
    wishListedItem,
    compareItems,
  } = props;
  const { variants, images } = Data;

  const inr = new Intl.NumberFormat("en-IN", { style: "decimal" });

  const colorArray = [
    ...new Map(item.variants.map((item) => [item.color, item])).values(),
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
  };


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const variant_id = queryParams.get("variant_id");
    let selectedVariant = [];
    let list = props.item.variants.map((item) => item.id == variant_id);
    if (list.includes(true))
      selectedVariant = props.item.variants.filter(
        (item) => item.id == variant_id,
      )[0];
    else {
      window.history.replaceState({}, "", window.location.href);
      selectedVariant = props.item.variants[0];
    }
    if (!selectedVariant) return;
    checkItemOnWishlist(selectedVariant.id);
    checkItemOnCompare(selectedVariant.id);
    setData((prevState) => ({
      ...prevState,
      variants: selectedVariant,
      images: selectedVariant.image ? selectedVariant.image.split(",") : [],
      inStock:
        props.item.made_to_order == "true" ? "Made to order" : "In Stock",
    }));
  }, []);

  // Re-check wishlist/compare status when Redux state updates.
  useEffect(() => {
    if (variants && variants.id) {
      checkItemOnWishlist(variants.id);
      checkItemOnCompare(variants.id);
    }
  }, [wishListedItem, compareItems, variants && variants.id]);

  const checkItemOnWishlist = (product_id) => {
    const found = wishListedItem.some(
      (element) =>
        element.variant && String(element.variant.id) === String(product_id),
    );
    setIsActive(found);
  };

  const checkItemOnCompare = (product_id) => {
    const found = compareItems.some(
      (element) =>
        element.variant && String(element.variant.id) === String(product_id),
    );
    setIsCompareActive(found);
  };

  const minusQty = () => {
    if (qty > 1) setQty(qty - 1);
    else setQty(1);
  };

  const plusQty = (item) => {
    if (item.made_to_order == "false") {
      if (item.stock > qty) {
        setQty(qty + 1);
      } else
        setData((prevState) => ({ ...prevState, inStock: "Out of Stock !" }));
    } else setQty(qty + 1);
  };

  const addToCart = (item) => {
    setAddingToCart(true);
    // addToCartClicked (addToCart action) now syncs to the server itself.
    props.addToCartClicked(item, qty, item.selectedVariant);
    setQty(1);
    setTimeout(() => setAddingToCart(false), 1000);
  };

  const handleWishlist = (item) => {
    if (isActive === true) {
      setIsActive(false);
      item.selectedVariant = variants;
      props.onRemoveFromWishlistClicked(item, item.selectedVariant);
    } else {
      setIsActive(true);
      item.selectedVariant = variants;
      props.addToWishlistClicked(item, item.selectedVariant);
    }
  };

  const handleCompare = (item) => {
    if (isCompareActive) {
      props.removeFromCompareClicked({
        id: item.id,
        variant: variants,
      });
    } else {
      item.selectedVariant = variants;
      props.addToCompareClicked(item, item.selectedVariant);
    }
  };

  const changeVariant = (vari) => {
    if (!vari) return;
    setData((prevState) => ({
      ...prevState,
      variants: vari,
      images: vari.image ? vari.image.split(",") : prevState.images,
    }));
    checkItemOnWishlist(vari.id);
    checkItemOnCompare(vari.id);
    window.history.replaceState(
      {},
      "",
      window.location.pathname + "?variant_id=" + vari.id,
    );
    props.setVariant(vari);
  };

  /*Color selector variant function call*/

  const colorHandle = (event) => {
    const color = event.currentTarget.value;
    let selectedItem = props.item.variants.filter(
      (item) => item.color == color && item.size == Data.variants.size,
    );
    if (selectedItem.length == 0)
      selectedItem = props.item.variants.filter((item) => item.color == color);

    changeVariant(selectedItem[0]);
  };

  /*Size selector variant function call*/

  const sizeHandle = (event) => {
    const size = event.currentTarget.value;
    let selectedItem = props.item.variants.filter(
      (item) => item.color == Data.variants.color && item.size == size,
    );
    if (selectedItem.length == 0)
      selectedItem = props.item.variants.filter((item) => item.size == size);
    changeVariant(selectedItem[0]);
  };

  /* Offer Section showing function*/
  const offerSectionShowing = () => {
    if (Data.variants.offers)
      return (
        <>
          <div>
            <button className="red-discount uk-button-secondary">
              <span
                uk-icon="icon: credit-card"
                className="uk-margin-small-right"
              ></span>
              <span className="normal-para">{Data.variants.offers}</span>
            </button>
          </div>
          <hr />
        </>
      );
  };

  const scrollToProductDetails = () => {
    const element = document.getElementById("sd-product-information");
    element.scrollIntoView({ behavior: "smooth" });
  };

  const copyLink = () => {
    const textToCopy =
      "https://sunnydiamonds.com/" +
      props.item.value +
      "?variant_id=" +
      Data.variants.id;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopyText("copied");
        setTimeout(() => setCopyText(""), 2000);
      })
      .catch((error) => {
        console.log("Copy failed: ", error);
      });
  };

  const getStarClass = (rating, starIndex) =>
    "fa fa-star" +
    (rating >= starIndex
      ? ""
      : rating > starIndex - 1 && rating < starIndex
        ? "-half-o"
        : "-o");

  const renderRating = () => {
    if (variants.rating === null || variants.rating <= 0) {
      return null;
    }

    return (
      <>
        {[1, 2, 3, 4, 5].map((starIndex) => (
          <i
            key={starIndex}
            className={getStarClass(variants.rating, starIndex)}
            color={starIndex === 1 ? "#FFCE00" : undefined}
            aria-hidden="true"
          />
        ))}
        <span className={classes.rating_text}>({variants.rating})</span>
      </>
    );
  };

  const colorClassMap = {
    "yellow-gold": classes.yellow,
    "rose-gold": classes.rose,
    "white-gold": classes.white,
  };
  const displayImages = images && images.length ? images : item.pictures || [];

  const isSizedCategory = ["rings", "bangles", "bracelets"].includes(
    item.category,
  );
  // Variants without a size can't be selected — their button would carry an
  // empty value and match nothing on lookup.
  const sizeOptions = item.variants.filter(
    (vari) => vari.color == variants.color && vari.size,
  );

  return (
    <div
      className={`product-detail-main ${classes.product_detail_page}`}
      style={{ width: "100vw", overflowX: "clip" }}
    >
      <div className="custom-container py-2 d-lg-none">
        <Breadcrumbs ancestor={item.name} currentPage="" />
      </div>
      {/* Image Slider in Mobile  */}
      <div className="d-lg-none uk-position-relative">
        <ProductImageSlider
          wrapClass="d-lg-none"
          imageArr={displayImages}
          itemName={item.name}
        />
        <ProductActions
          classes={classes}
          item={item}
          variants={variants}
          isActive={isActive}
          isCompareActive={isCompareActive}
          onWishlist={handleWishlist}
          onCompare={handleCompare}
          onCopyLink={copyLink}
          copyText={copyText}
        />
      </div>

      {/* Product Detail Section  */}
      <div className="uk-container uk-container-xlarge">
        <div className={classes.detail_container}>
          <div className="d-none d-lg-block">
            <Breadcrumbs ancestor={item.name} currentPage="" />
          </div>
          <div className={classes.detail_wrapper}>
            {/* Image Grid in WEB  */}
            <div className={`${classes.image_content} d-none d-lg-block`}>
              <ProductImageGrid imageArr={displayImages} itemName={item.name} />
              <ProductActions
                classes={classes}
                item={item}
                variants={variants}
                isActive={isActive}
                isCompareActive={isCompareActive}
                onWishlist={handleWishlist}
                onCompare={handleCompare}
                onCopyLink={copyLink}
                copyText={copyText}
              />
            </div>

            {/* Contents Section  */}
            <div className={classes.product_details}>
              <h1 className={classes.product_title}>
                {item.name.toUpperCase()}
              </h1>

              <div className="uk-flex">
                <p className={`uk-flex ${classes.pdp_sku}`}>
                  SKU: {item.sku.toUpperCase()}
                </p>
                {/* Product Rating  */}
                <div className={classes.star_rating}>{renderRating()}</div>
                {true && (
                  <div
                    className="pl-2 border-left text-uppercase"
                    style={{
                      paddingTop: "2px",
                      marginLeft: "14px",
                      color: "rgb(114, 34, 87)",
                      fontWeight: 700,
                    }}
                  >
                    Made to Order
                  </div>
                )}
              </div>

              {/* Price Section */}
              <div className={classes.price_section}>
                <div className={classes.price_inner}>
                  {variants.offerprice ? (
                    <p className={classes.price_text}>
                      <span>
                        {symbol} {inr.format(variants.offerprice)}{" "}
                      </span>
                      <span className={classes.price_sub_text}>
                        (MRP Inclusive of all taxes)
                      </span>
                    </p>
                  ) : (
                    <ButtonSpinner color={"#722257"} />
                  )}
                  <div className={classes.price_breakup}>
                    <PriceBreakUp symbol={symbol} noIcon product={variants} />
                  </div>
                </div>
                <p className={classes.note_text}>
                  Actual weight and specifications may vary slightly. Final
                  pricing is based on the exact weight of the product.
                </p>
              </div>

              {/* {offerSectionShowing()} */}

              {/* Color & Size Options  */}
              <div className="uk-width-1-1@l form-select-size">
                <form onSubmit={handleSubmit}>
                  <fieldset className="uk-fieldset">
                    <div>
                      {/* Color Options  */}
                      <div
                        className={classes.product_color_options}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                        }}
                      >
                        <div>
                          <label
                            className={classes.section_title}
                            htmlFor="form-stacked-select"
                          >
                            Color
                          </label>
                          <div className={classes.option_wrapper}>
                            {colorArray.map((element, i) => {
                              const colorClass =
                                colorClassMap[element.color] || classes.white;
                              const value = element.color || classes.yellow;
                              const activeClass =
                                element.color === variants.color
                                  ? classes.active
                                  : "";

                              return (
                                <button
                                  key={element.id || i}
                                  className={`${classes.option_item} ${colorClass} ${activeClass}`}
                                  onClick={colorHandle}
                                  value={value}
                                ></button>
                              );
                            })}
                          </div>
                        </div>
                        {true && (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              backgroundColor: "rgb(255, 248, 242)",
                              border: "1px solid rgb(232, 201, 160)",
                              borderRadius: "6px",
                              padding: "8px 14px",
                            }}
                          >
                            <span
                              style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: "rgb(114, 34, 87)",
                                display: "inline-block",
                                flexShrink: 0,
                              }}
                            ></span>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 700,
                                color: "rgb(114, 34, 87)",
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                              }}
                            >
                              Made to Order
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Size Options  */}
                      {isSizedCategory && sizeOptions.length > 0 ? (
                        <div className={classes.product_size_options}>
                          <div className={classes.option_header}>
                            <label
                              className={classes.section_title}
                              htmlFor="form-stacked-select"
                              style={{ justifyContent: "space-between" }}
                            >
                              Select Size
                            </label>
                            <Link
                              to={
                                `${process.env.PUBLIC_URL}/` + item.category !=
                                  "rings"
                                  ? "education/size-chart/ring-size-guide"
                                  : "education/size-chart/bangle-and-bracelet-size-guide"
                              }
                              className={classes.size_chart}
                            >
                              Size Guide
                            </Link>
                          </div>
                          <div className={classes.option_wrapper}>
                            {sizeOptions.map((vari, i) => (
                              <div key={vari.id || i}>
                                <button
                                  className={`${classes.option_item} ${vari.size === variants.size
                                    ? classes.active
                                    : ""
                                    }`}
                                  onClick={sizeHandle}
                                  value={vari.size}
                                >
                                  {vari.size}
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </fieldset>
                </form>
              </div>

              {/* Product Counter  */}
              <div className={classes.product_counter}>
                <h4 className={classes.section_title}>Quantity</h4>
                <QuantityCounter
                  qty={qty}
                  onDecrement={minusQty}
                  onIncrement={() => plusQty(item)}
                />
              </div>

              {/* Desktop view for quantity selector, buy now button and add to cart button */}
              <div className={`${classes.action_buttons} d-none d-md-flex `}>
                <Link
                  style={{ zIndex: 0 }}
                  to={`${process.env.PUBLIC_URL}/checkout`}
                  className="uk-button uk-button-primary buy-now uk-width-1-1"
                  onClick={() => {
                    item.selectedVariant = variants;
                    BuynowClicked(item, qty, item.selectedVariant);
                  }}
                >
                  buy now
                </Link>
                <button
                  style={{ zIndex: 0 }}
                  className="uk-button uk-button-secondary add-cart uk-width-1-1"
                  onClick={() => {
                    item.selectedVariant = variants;
                    addToCart(item);
                  }}
                  disabled={addingToCart}
                >
                  {addingToCart ? (
                    <ButtonSpinner color={"#000"} />
                  ) : (
                    "Add To Cart"
                  )}
                </button>
                {/* {Data.variants.stock > 0 &&
                  <div className="uk-visible@m">
                    <StockDetails data={Data} />
                  </div>
                } */}
              </div>

              {/*Service icons section */}
              {/* <div
              className="uk-flex uk-flex-wrap uk-flex-between uk-child-width-auto uk-flex-middle uk-padding-remove uk-margin-remove"
              style={{ overflowX: 'auto' }}
            >
              <div className="uk-flex uk-flex-column uk-flex-middle uk-padding-small">
                <span className="uk-icon uk-margin-small-bottom">
                  <img src="/assets/images/icon/replacement_service.png" alt="Service Centre Replacement" width="32" height="32" />
                </span>
                <span className="uk-text-small uk-text-center" style={{ color: "#722257" }}>
                  15 Days Return
                </span>
              </div>
              <div className="uk-flex uk-flex-column uk-flex-middle uk-padding-small">
                <span className="uk-icon uk-margin-small-bottom">
                  <img src="/assets/images/icon/free_delivery.png" alt="Free Delivery" width="32" height="32" />
                </span>
                <span className="uk-text-small uk-text-center" style={{ color: "#722257" }}>
                  Free Delivery
                </span>
              </div>
              <div className="uk-flex uk-flex-column uk-flex-middle uk-padding-small">
                <span className="uk-icon uk-margin-small-bottom">
                  <img src="/assets/images/icon/cash_on_delivery.png" alt="Cash/Pay on Delivery" width="32" height="32" />
                </span>
                <span className="uk-text-small uk-text-center" style={{ color: "#722257" }}>
                  Cash/Pay on<br />Delivery
                </span>
              </div>
              <div className="uk-flex uk-flex-column uk-flex-middle uk-padding-small">
                <span className="uk-icon uk-margin-small-bottom">
                  <img src="/assets/images/icon/top_brand.png" alt="Top Brand" width="32" height="32" />
                </span>
                <span className="uk-text-small uk-text-center" style={{ color: "#722257" }}>
                  Top Brand
                </span>
              </div>
              <div className="uk-flex uk-flex-column uk-flex-middle uk-padding-small">
                <span className="uk-icon uk-margin-small-bottom">
                  <img src="/assets/images/icon/secure_transaction.png" alt="Secure transaction" width="32" height="32" />
                </span>
                <span className="uk-text-small uk-text-center" style={{ color: "#722257" }}>
                  Secure<br />transaction
                </span>
              </div>
            </div> */}

              {/* <hr className="m-2"/>
            {variants.features && variants.features.split(',').includes("try_@_home") && (
              <>
                <TryAtHomePDP
                  item={item}
                  imageArray={images}
                  symbol={symbol}
                />
                <hr className="m-2"/>
              </>
            )} */}
              {/* Fair Pricing Box */}
              {variants.price !== 0 && (
                <div className={classes.fair_pricing}>
                  <div className={classes.row}>
                    <p className={classes.title}>Fair Pricing</p>
                    <a
                      href={`${process.env.PUBLIC_URL}/fair-pricing`}
                      target="_blank"
                      className={classes.learn_more}
                    >
                      Learn More
                    </a>
                  </div>
                  <div className={`${classes.sunny_row} ${classes.row} `}>
                    <span>Sunny Diamonds</span>
                    <span className={classes.price}>
                      {symbol} {inr.format(variants.offerprice)}
                    </span>
                  </div>
                  <div className={`${classes.estimated_row} ${classes.row} `}>
                    <span>Estimated Retail</span>
                    <span className={classes.price}>
                      {symbol} {inr.format(variants.price)}
                    </span>
                  </div>
                </div>
              )}

              <ProductDescription item={variants} />

              {/* commented because the section is missing in new design  */}
              {/* <div className="uk-placeholder uk-text-center uk-padding-small">
                <div className="uk-text-center">
                  <p className="uk-margin-remove tw-text-sm">
                    Need help to find the best jewellery for you ?
                  </p>
                  <p className="uk-text-small uk-margin-remove tw-text-sm">
                    We are available for your assistance
                  </p>
                </div>
                <div
                  className="uk-text-center uk-flex-center uk-margin-small-top"
                  data-uk-grid
                >
                  <div>
                    <div>
                      <a
                        href="tel:+919744355555"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="uk-icon-button"
                        data-uk-icon="icon: receiver"
                      ></a>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a
                        href="https://api.whatsapp.com/send?phone=919961870099"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="uk-icon-button"
                        data-uk-icon="icon: whatsapp"
                      ></a>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a
                        href="mailto:customerservice@sunnydiamonds.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="uk-icon-button"
                        data-uk-icon="icon: mail"
                      ></a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Buy Now and Add to Cart Mobile */}
      <div className={`${classes.mobile_action_buttons} d-sm-none`}>
        <Link
          style={{ zIndex: 1 }}
          to={`${process.env.PUBLIC_URL}/checkout`}
          className={classes.primary_btn}
          // onClick={() => BuynowClicked(item, qty, item.selectedVariant)}
          onClick={() => {
            item.selectedVariant = variants;
            BuynowClicked(item, qty, item.selectedVariant);
          }}
        >
          Buy Now
        </Link>
        <button
          style={{ zIndex: 1 }}
          className={classes.secondary_btn}
          onClick={() => {
            item.selectedVariant = variants;
            addToCart(item);
          }}
          disabled={addingToCart}
        >
          {addingToCart ? <ButtonSpinner color={"#000"} /> : "Add To Cart"}
        </button>
      </div>
    </div>
  );
};

export default ProductDetails;
